<template lang="pug">
  div.NtRecord
    van-dropdown-menu(class="select_box")
      van-dropdown-item(v-model="active", :options="status")
    van-collapse(v-model="record", v-if='loadingR==="loadedR"', accordion)
      van-collapse-item(class="ntRecord_list", v-for='item in orderList')
        template(#icon)
          img(class="ntRecord_icon", :src="item.appIcon")
        template(#title)
          p.title {{item.totalMoney}}
          p.time {{formatDate(item.paySuccessTime, true)}}
        template(#value)
          p.status {{formatStatus(item.status)}}
        p {{$t('orderID')}}{{item.id}}
        p {{$t('accountUID')}}{{item.uid}}
        p {{$t('totalAmount')}}{{item.currency}}  {{item.totalMoney}}
        p {{$t('paymentChannel')}}{{item.orderTypeName}}
        p {{$t('orderCreationTime')}}{{formatDate(item.createTime)}}
        p {{$t('orderPaymentTime')}}{{formatDate(item.paySuccessTime)}}
        p {{$t('rechargeGamePoint')}}{{item.point}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'NtRecord',
  data($vm){
    return{
      active: -1,
      record: '',
      orderList:{}
    }
  },
  created(){
    this.getROrderList(Qs.stringify({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      pageNumber: 1,
      language: this.lang
    }))
  },
  methods:{
    ...mapActions('user', ['getROrderList'])
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'lang']),
    ...mapGetters('user', ['loadingR', 'rOrderList']),
    status: $vm => {
      return [
        {
          text: $vm.$t('all'),
          value: -1
        },
        {
          text: $vm.$t('toBePaid'),
          value: 0
        },
        {
          text: $vm.$t('tradeSuccess'),
          value: 100
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        let payDate = new Date(parseInt(val));
        if(key){
          return payDate.getFullYear() + '-' + payDate.getMonth() + 1 + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds() + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
        } else {
          return payDate.getFullYear() + '-' + payDate.getMonth() + 1 + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds()
        }
      }
    },
    formatStatus: $vm => {
      return val => {
        if(val === '0'){
          return $vm.$t('toBePaid')
        } else if(val === '50'){
          return $vm.$t('paymentSuccess')
        } else if(val === '100'){
          return $vm.$t('tradeSuccess')
        }
      }
    }
  },
  mounted(){
    this.$watch('loadingR', val => {
      if(val === 'loadedR'){
        this.orderList = this.rOrderList.purchaseOrderList
        console.log(this.rOrderList);
      }
    })
  }
}
</script>
<style lang="scss">
.NtRecord{
  margin: 20px;
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .ntRecord_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 40px;
      line-height: 60px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      line-height: 60px;
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .ntRecord_icon{
    height: 60px;
    width: 60px;
    position: relative;
  }
  .title{
    margin: 0;
    margin-top: 10px;
    font-size: 18px;
    color: #000;
    padding-left: 10px;
    font-weight: bolder;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
  }
  .van-hairline--top-bottom::after{
    border-width: 0px;
  }
}
</style>